export default __webpack_public_path__ + "static/media/alex_vieira.fa881ea6.jpg";